import React, { useState, useEffect } from 'react'
import QrReader from 'react-qr-scanner'
import Swal from 'sweetalert2'
import { Obras, Emprestimos } from '../../services/http'
import BasicModal from '../../components/shared/modals/BaseModal'
import FormEmprestimo from './components/formEmprestimo'

const AutoEmprestimo = () => {
  const [statusVideo, setStatusVideo] = useState('')
  const [statusModal, setStatusModal] = useState(false)
  const [statusEmprestimo, setStatusEmprestimo] = useState()
  const [exemplar, setExemplar] = useState({})

  const handleScan = data => {
    if (data !== null && statusEmprestimo === true) {
      emprestar(data?.text)
    }
    if (data !== null && statusEmprestimo === false) {
      devolver(data?.text)
    }
  }

  const emprestar = async idExemplar => {
    setStatusVideo('user')
    const emprestimo = await fetchEmprestimo(idExemplar)
    if (!emprestimo) {
      const exemplar = await fetchExemplar(idExemplar)
      setExemplar(exemplar)
      confirmBookLoan(exemplar)
    } else {
      await Swal.fire({
        title: 'O livro possui registro de emprestimo!',
        text: `Faça a devolução para poder efetuar o emprestimo.`,
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Voltar'
      }).then(() => {
        init()
      })
    }
  }

  const devolver = async idExemplar => {
    setStatusVideo('user')
    const emprestimo = await fetchEmprestimo(idExemplar)
    if (!emprestimo) {
      await Swal.fire({
        text: `O livro não possui registro de emprestimo!`,
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Voltar'
      }).then(() => {
        init()
      })
    } else {
      const exemplar = await fetchExemplar(idExemplar)
      setExemplar(exemplar)
      confirmBookReturn(exemplar, emprestimo)
    }
  }

  const fetchEmprestimo = async idExemplar => {
    const { data } = await Emprestimos().show({
      exemplar_id: idExemplar
    })
    return data.data[0]?.id
  }

  const deleteEmprestimo = async idEmprestimo => {
    await Emprestimos(idEmprestimo).delete(
      {},
      { notification: true, message: 'Livro devolvido com sucesso!' }
    )
    init()
  }

  const fetchExemplar = async idExemplar => {
    const { data } = await Obras().show({
      'includes[exemplares][id]': idExemplar
    })
    return {
      id: data.data[0]?.exemplares[0]?.id,
      titulo: data.data[0]?.titulo
    }
  }

  const confirmBookLoan = async exemplar => {
    await Swal.fire({
      title: 'Emprestar Livro',
      text: `Deseja emprestar o livro: ${exemplar.titulo}?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Cancelar'
    }).then(result => {
      result.isConfirmed ? setStatusModal(result.isConfirmed) : init()
    })
  }

  const confirmBookReturn = async (exemplar, emprestimo) => {
    await Swal.fire({
      title: 'Devolução',
      text: `Deseja devolver o livro: ${exemplar.titulo}?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Cancelar'
    }).then(result => {
      result.isConfirmed ? deleteEmprestimo(emprestimo) : init()
    })
  }

  const handleError = err => {
    console.error(err)
  }
  const delay = 1000
  const previewStyle = {
    height: 240,
    width: 320
  }

  const init = () => {
    Swal.fire({
      title: 'Auto Emprestimo',
      text: `Deseja emprestar um livro?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Emprestar',
      cancelButtonText: 'Devolver'
    }).then(result => {
      setStatusEmprestimo(result.isConfirmed)
      setStatusVideo('environment')
    })
  }

  useEffect(() => {
    init()
  }, [])

  return (
    <div className="container-scan">
      <div>
        <QrReader
          delay={delay}
          style={previewStyle}
          onError={handleError}
          onScan={handleScan}
          constraints={{
            video: {
              facingMode: { exact: statusVideo }
            }
          }}
        >
          <BasicModal
            status={statusModal}
            Caller={() => {}}
            closeEvent={event => {
              setStatusModal(event)
            }}
            title="Emprestar"
            sx={{ minWidth: '60vw', width: { xs: '100vw', md: '60vw' } }}
          >
            <>
              <FormEmprestimo
                exemplar={exemplar}
                valueModal={value => {
                  setStatusModal(value)
                  init()
                }}
              />
            </>
          </BasicModal>
        </QrReader>
      </div>
    </div>
  )
}

export default AutoEmprestimo
